<template>
    <div class="alert">

        <v-alert :color="color" class="alert-message">

            <template #title>
                <slot name="title">
                    {{ title }}
                </slot>
            </template>

            <slot>
                {{ text }}
            </slot>
        </v-alert>

    </div>
</template>

<script>
export default {
    name: 'Alert',
    props: {
        title: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: 'color1'
        }
    }
}
</script>

<style scoped>
.alert {
    width: 100%;
}

.alert-message {
    text-align: left;
    border-radius: 8px;
    padding: 16px 32px;
}

@media (max-width: 800px) {
    .alert {
        font-size: 13px;
    }

    .alert-message {
        padding: 12px 16px;
    }
}
</style>